import { type SystemStyleObject } from '@mui/system'
import { type ReactNode } from 'react'
import { BlockButton } from '../../customComponents/buttons/BlockButton'
import { BlueButton } from '../../customComponents/buttons/BlueButton'

const figmaButton = {
  fontFamily: 'Raleway',
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: 1.7,
  padding: '12px 24px',
  borderRadius: '4px'
}

const fullWidth = (enabled: boolean | undefined): SystemStyleObject => enabled === true ? { width: '100%' } : {}

interface P2PButtonProps {
  onClick: () => void
  disabled?: boolean
  startIcon?: JSX.Element
  endIcon?: JSX.Element
  fullWidth?: boolean
  type?: 'button' | 'submit'
  dataTestId?: string
  sx?: SystemStyleObject
  children: ReactNode
}

export const P2PPrimaryButton = (props: P2PButtonProps): JSX.Element => (
  <BlueButton
    onClick={props.onClick}
    disabled={props.disabled}
    startIcon={props.startIcon}
    endIcon={props.endIcon}
    type={props.type}
    dataTestId={props.dataTestId}
    border='none'
    disabledSx={{ color: 'var(--grey-900)', background: 'var(--grey-300)' }}
    sx={{ ...figmaButton, ...fullWidth(props.fullWidth), ...props.sx }}
  >
    {props.children}
  </BlueButton>
)

export const P2PSecondaryButton = (props: P2PButtonProps): JSX.Element => (
  <BlockButton
    onClick={props.onClick}
    disabled={props.disabled}
    startIcon={props.startIcon}
    endIcon={props.endIcon}
    type={props.type}
    dataTestId={props.dataTestId}
    color='var(--grey-700)'
    hoverColor='var(--grey-900)'
    border='1px solid var(--grey-100)'
    sx={{ ...figmaButton, ...fullWidth(props.fullWidth), '& .MuiButton-startIcon svg': { fontSize: '20px', color: 'var(--grey-500)' }, ...props.sx }}
  >
    {props.children}
  </BlockButton>
)
